import {
  AccessEnum,
  AccessRoleEnum,
  ServiceAccessEnum,
} from '@sr-sdks/api-sdk-axios';
import { ReactNode } from 'react';
import CollectionAccountAccessDenied from '../pages/Workspace/Title/CollectionAccountAccessDenied';
import { beneficiaryService } from '../reducers/services/beneficiarySlice';
import { useTypedSelector } from '../stateStore';

interface IIfHasServiceAccessProps {
  accessRequired: ServiceAccessEnum;
  children: ReactNode;
  roleRequired?: AccessRoleEnum[];
  showNoAccessError?: boolean;
}

const IfHasServiceAccess = ({
  accessRequired,
  children,
  roleRequired = Object.values(AccessRoleEnum), // Default to any role
  showNoAccessError = false,
}: IIfHasServiceAccessProps) => {
  const currentBeneficiary = useTypedSelector(
    beneficiaryService.selectors.currentBeneficiary,
  );

  const hasAccess =
    currentBeneficiary &&
    currentBeneficiary.serviceAccessRole &&
    currentBeneficiary.serviceAccessRole.access[accessRequired] ===
      AccessEnum.Allow;

  const hasRole =
    currentBeneficiary &&
    currentBeneficiary.serviceAccessRole &&
    roleRequired?.includes(currentBeneficiary.serviceAccessRole.role);

  if (hasAccess && hasRole) return children;

  if (showNoAccessError) return <CollectionAccountAccessDenied />;

  return <> </>;
};

export default IfHasServiceAccess;
